module.exports = {
	"pathContext": {}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/pricing.json
// module id = 2004
// module chunks = 93449047059328